import qs from 'qs';

export const waitForBackend = () => {
    let waitForBackend = false;
    if (window.location.search) {
        const searchParams = qs.parse(window.location.search.replace('?', ''));
        waitForBackend = !!searchParams.updateditems;
    }
    return waitForBackend;
};
